var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1684 20V10.8777H14.4535L15.0963 7.32156H10.1684V5.05147C10.1684 4.0222 10.5669 3.32076 12.6356 3.32076L15.2698 3.31999V0.13923C14.8142 0.0969453 13.2505 0 11.4305 0C7.6301 0 5.02825 1.65697 5.02825 4.69927V7.32156H0.730225V10.8777H5.02825V20H10.1684Z",
    fill: "#295F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3db65812211204bfab9efe7289dca741.svg";
export { ForwardRef as ReactComponent };